
export default function Webpage ({ cue }) {
  
  return (
    <iframe
      key={cue.refreshCount}
      className={`webpage_key flex
        w-screen
        h-screen
        overflow-none
      `}
      id={cue.id}
      title={cue.name}
      src={cue.url}
      scrolling={cue.interactable ? "yes" : "no"}
      frameBorder="0"
      style={{ color: "blue !important" }}
    ></iframe>
  )
}